export default __webpack_public_path__ + "static/media/bentley.1f0c3578.svg";